import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import ErrorState, { ErrorBoundary } from '@/components/Error';
import Tabs from '@/components/Tabs';
import { LearnerWidgetProps } from '@/modules/learner/views/LearnerProfile/types';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import LearnerProfileBanner from '../LearnerProfileBanner';
import LearnerProfileHeader from './components/LearnerProfileHeader';
import useLearnerProfileTabs from './hooks/useLearnerProfileTabs';
import { LEARNER_PROFILE_TABS_CONFIG } from './hooks/useLearnerProfileTabs/utils';
import { maxW1440, px72 } from './styles';
import { getLearnerProfileWidgets } from './utils';

function LearnerProfileContent(props: LearnerWidgetProps) {
  const { learner, onAction, isCurrentUser } = props;
  const isAdmin = useAdminRoute();

  const widgets = getLearnerProfileWidgets(learner, isAdmin);
  const { activeTab, tabs } = useLearnerProfileTabs({ learnerId: learner.id });
  const TabComponent = LEARNER_PROFILE_TABS_CONFIG[activeTab]?.Component;

  return (
    <>
      <LearnerProfileHeader learner={learner} onAction={onAction} />
      <LearnerProfileBanner learner={learner} />
      <Stack className={cn('mx-auto w-full flex-1 py-48', px72, maxW1440)} gapX={56}>
        <Stack direction="col" gapY={24}>
          {widgets.map(({ key, Component }) => (
            <Component
              key={key}
              isCurrentUser={isCurrentUser}
              learner={learner}
              onAction={onAction}
            />
          ))}
        </Stack>
        <Stack className="flex-1 w-full overflow-auto" direction="col" gapY={24}>
          <Tabs className="mt-8 px-16" tabs={tabs} value={activeTab} />
          <ErrorBoundary fallback={ErrorState}>
            {TabComponent ? (
              <TabComponent
                useWindowScroll
                isCurrentUser={isCurrentUser}
                learner={learner}
                onAction={onAction}
              />
            ) : null}
          </ErrorBoundary>
        </Stack>
      </Stack>
    </>
  );
}

export default LearnerProfileContent;
